module.exports = __webpack_public_path__ + "static/media/vincenzo-ruffa.c63fcde8.jpg";